module.exports = __webpack_public_path__ + "img/pemkot2.795fbdf2.jpeg";